import React, { useEffect, useState } from "react"
import Modal from "react-bootstrap/Modal"
import Select from "react-select"
import Button from "../../../components/Button"
import Toast from "../../../components/Toast"
import {
  getAllCenters,
  getPatientDetail,
  transferPatient
} from "../../../core/services/api"
import { getDisabledCenters } from "../../../core/services/api/migrationService"
import "./ViewTransferPatient.scss"

function ViewTransferPatient({ show, closePrintModal, id }: any) {
  // const { id } = props
  // const [show, setShow] = useState(true)
  const [data, setData] = useState<any>()
  const [centerData, setCenterData] = useState<any>()
  // const [toCenterData, setToCenterData] = useState<any>()
  const [displayToast, toggleDisplayToast] = useState<any>()

  const [transferPatientInfo, setTransferPatientInfo] = useState<any>({
    name: "",
    MocId: "",
    CurrentCenter: "",
    TransferPatient: "",
  })
  const [close, setClose] = useState<any>(false)
  const [transferPatientCenters, setTransferPatientCenters] = useState<any>()
  const [isFromDisabledCenter, setIsFromDisabledCenter] = useState(false)
  const [disabledCenterIds, setDisabledCenterIds] = useState<string[]>([])

  const fetchPatientDetails = () => {
    getPatientDetail(id)
      .then((res) => {
        setData(res)
        if (res) {
          // toggleDisplayToast({
          //   text: "Transferred Patient Successfully",
          //   type: "success",
          // })
        }

        setTransferPatientInfo({
          name: res.name,
          mocId: res.mocId,
          currentCenter: res?.centers[0].centerName,
        })
      })
      .catch((err) => {
        console.log("Error", err)
      })
  }
  const fetchAllcenterDetails = () => {
    getAllCenters()
      .then((res) => {
        setCenterData(res)
        let tempCenters: any = res?.map((each: any) => {
          return { label: each?.centerName, value: each?.id }
        })

        setTransferPatientCenters(tempCenters)
      })
      .catch((err) => {
        console.log("err", err)
      })
  }

  useEffect(() => {
    fetchPatientDetails()
    fetchAllcenterDetails()
    getDisabledCenters()
      .then((response: any) => {
        const disabled = response?.disabledCenters || []
        setDisabledCenterIds(disabled.map((c: any) => c.id))
      })
      .catch((error) => {
        console.error("Error fetching disabled centers:", error)
      })
  }, [])

  const handleClose = () => {
    // setShow(false)
    closePrintModal(false)
  }

  const handleCloses = () => {
    console.log(close)
    setClose(false)
  }
  const handleSubmit = (e: any) => {
    e.preventDefault()
    let fromCenterId = data?.centers[0].centerId
    let toCenterIdtest = transferPatientInfo?.TransferPatient
    transferPatient(data.id, fromCenterId, toCenterIdtest)
      .then((res) => {
        toggleDisplayToast({
          text: "Transferred Patient Successfully",
          type: "success",
        })
      })
      .catch((err) => {
        toggleDisplayToast({
          text: "Please select branch to transfer",
          type: "error",
        })
      })
  }
  useEffect(() => {
    if (data && disabledCenterIds.length > 0) {
      const fromCenterId = data?.centers?.[0]?.centerId
      if (fromCenterId && disabledCenterIds.includes(fromCenterId)) {
        setIsFromDisabledCenter(true)
        toggleDisplayToast({
          text: `This patient belongs to a disabled center. Transfer is not allowed.`,
          type: "error",
        })
      }
    }
  }, [data, disabledCenterIds])

  useEffect(() => {
    if (
      transferPatientInfo.currentCenter === transferPatientInfo?.TransferPatient
    ) {
      console.log(
        transferPatientInfo.currentCenter ===
        transferPatientInfo?.TransferPatient
      )
      setClose(true)
    } else {
      setClose(false)
    }
  }, [transferPatientInfo?.TransferPatient])
  console.log(close)
  return (
    <div>
      <Modal size="xl" show={show} onHide={handleClose}>
        <Modal.Header closeButton>
          <Modal.Title>Transfer Patient</Modal.Title>
        </Modal.Header>
        <Modal.Body>
          <div className="transfer-patient-container">
            <form onSubmit={handleSubmit}>
              <div className="row row-section">
                <div className="col-3 key-container">Patient Id:</div>
                {/* <div className="col-3">{data?.name}</div> */}
                <div className="col-3 value-container">
                  {transferPatientInfo.mocId}
                </div>
              </div>
              {!data?.isVIP && (
                <div className="row row-section">
                  <div className="col-3 key-container">Name:</div>
                  {/* <div className="col-3">{data?.name}</div> */}
                  <div className="col-3 value-container">
                    {transferPatientInfo.name}
                  </div>
                </div>
              )}
              <div className="row row-section">
                <div className="col-3 key-container">Current Center:</div>
                <div className="col-3 value-container">
                  {transferPatientInfo.currentCenter}
                </div>
              </div>
              <div className="row row-section">
                <div className="col-3 key-container">Transfer Patient:</div>
                <div className="col-3 value-container">
                  <Select
                    styles={{
                      control: (provided, state) => ({
                        ...provided,
                        border: "1px solid #ccd0e7",
                        borderRadius: "10px",
                      })
                    }}
                    options={transferPatientCenters?.filter((center: any) => center.label !== transferPatientInfo?.currentCenter)}
                    onChange={(option: any) => {
                      setTransferPatientInfo({
                        ...transferPatientInfo,
                        TransferPatient: option?.value,
                      })
                    }
                    }
                    filterOption={(option, inputValue) =>
                      option.label.toLowerCase().includes(inputValue.toLowerCase())
                    }
                    placeholder="Transfer Patient"
                  />
                </div>
              </div>
              {transferPatientInfo.currentCenter ===
                transferPatientInfo?.TransferPatient ? (
                <div className="button-alignment">
                  <div>
                    <Button
                      disabled
                      text="Transfer Patient"
                      type="submit"
                      id="transfer-patient"
                    />
                  </div>
                </div>
              ) : (
                <div className="button-alignment">
                  <div>
                    <Button
                      text="Transfer Patient"
                      type="submit"
                      id="transfer-patient"
                    />
                  </div>
                </div>
              )}
            </form>
          </div>
        </Modal.Body>
      </Modal>
      {close && (
        <Toast
          textMessage={"Current Center and Transfer Patient Should Not Be Same"}
          onClose={() => handleCloses()}
          onCloseText="Close"
          type={"warning"}
        />
      )}
      {displayToast && (
        <Toast
          textMessage={displayToast?.text}
          onClose={() => {
            toggleDisplayToast(false)
            if (displayToast?.type === "success") {
              closePrintModal(false)
            }
          }}
          onCloseText="Close"
          type={displayToast?.type}
        />
      )}
    </div>
  )
}

export default ViewTransferPatient
